import styled from 'styled-components';

import Button from '@components/Button/next';
import { SimpleButton } from '@components/formStyles';

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: ${(p) => p.theme.palette.darkGrey};
  margin: 0;
`;

export const TitleMobile = styled.h2`
  font-weight: 700;
  color: ${(p) => p.theme.palette.darkGrey};
  margin: 0;
  font-size: 20px;
`;
export const Content = styled.div`
  margin-top: 30px;
  position: relative !important;
  display: grid;
  gap: 10px;

  .guest-wrapper {
    width: 100%;
    background-color: white;
    padding: 15px 15px;
  }
  .react-tiny-popover-container {
    /* width: 50% !important; */
    position: relative;
  }

  @media (max-width: 500px) {
    .react-tiny-popover-container {
      width: 420px !important;
      position: relative;
    }
  }
`;

export const Footer = styled.div`
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  position: relative;
  width: 100%;

  @media (max-width: 500px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 30px;
  }
`;

export const FooterMobile = styled.div`
  display: flex;
  width: 100%;
  margin-top: 15px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const StyledButton = styled(Button)`
  width: 250px;
  height: 58px;
  margin-left: 20px;
  border-radius: 8px;
  span {
    font-size: 18px;
    font-weight: bold;
  }

  @media (max-width: 500px) {
    width: 90%;
    order: -1;
    margin-left: -30px;
  }
`;

export const StyledSimpleButton = styled(SimpleButton)`
  font-size: 14px;
  font-weight: bold;

  color: ${({ theme }) => theme.palette.eclipse};

  @media (max-width: 500px) {
    margin-left: -10px;
    margin-top: 21px;
  }
`;

export const InputWrapper = styled.div`
  width: 337px;
  height: auto;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    width: 100%;
  }
`;

export const DynamicRow = styled.div`
  display: flex;
  justify-content: space-between;

  margin-top: 15px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    flex-direction: column;
    justify-content: center;
    margin-top: 0;
  }
`;

export const SearchItemWrapper = styled.div`
  border-radius: 8px;
  overflow: hidden;
  & div.react-tiny-popover-container {
    max-width: 686px !important;
    width: 686px !important;
  }
`;

StyledButton.defaultProps = {
  variant: 'Primary',
};
export const SearchShipWrapper = styled.div`
  & div.react-tiny-popover-container {
    max-width: 694px !important;
    width: 694px !important;
  }
`;
export const SearchWrapper = styled.div<{ searchType?: string }>`
  & div.react-tiny-popover-container {
    max-width: ${({ searchType }) =>
      searchType === 'tourDetail' ? 757 : null}px !important;
    width: ${({ searchType }) =>
      searchType === 'tourDetail' ? 757 : null}px !important;
  }
`;
